import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import { TextField } from 'redux-form-material-ui';
import { Field } from 'redux-form';
import { required } from '../../lib/validators';
import { Row, Col } from 'react-flexbox-grid';
import {LoomisColors} from '../../lib/LoomisColors';
import translate from '../../lib/i18n/translate'

import './LoginForm.css'

const styles = {
    errorStyle: {
       color: LoomisColors.red,
    },
    underlineStyle: {
        borderColor: LoomisColors.darkerRed,
    },
    floatingLabelStyle: {
        color: LoomisColors.blueGrey,
    },
    floatingLabelFocusStyle: {
        color: LoomisColors.blueGrey,
    },
    textFieldStyle: {
        color: LoomisColors.white,
    },
};

const LoginForm = ({handleSubmit, user, username, password, login}) => {

    return (
        <div className="FormWrapper">
        <div className="container">
        <Row>
            <Col xs={12}>
                <Row center="xs">
                    <Col xs={12} sm={6} md={4}>
                        {user.error && 
                            <div className="error">
                                {user.error.message}
                            </div>
                        }

                        <form className="Login" onSubmit={handleSubmit}>
                            <div>
                                <Field
                                    name="username"
                                    validate={[required]}
                                    component={TextField}
                                    floatingLabelText={username}
                                    fullWidth={true}
                                    // errorText="This field is required"
                                    errorStyle={styles.errorStyle}
                                    underlineFocusStyle={styles.underlineStyle}
                                    floatingLabelStyle={styles.floatingLabelStyle}
                                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                    inputStyle={styles.textFieldStyle}
                                    />
                            </div>
                            <div>
                                <Field
                                    name="password"
                                    type="password"
                                    validate={[required]}
                                    component={TextField}
                                    floatingLabelText={password}
                                    fullWidth={true}
                                    // errorText="This field is required"
                                    errorStyle={styles.errorStyle}
                                    underlineFocusStyle={styles.underlineStyle}
                                    floatingLabelStyle={styles.floatingLabelStyle}
                                    floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                    inputStyle={styles.textFieldStyle}
                                    />
                            </div>
                            <div className="ButtonWrapper">
                            <FlatButton
                                type="submit"
                                disabled={user.loading}
                                backgroundColor="#fff"
                                label={login}
                                fullWidth={true} />
                            </div>
                        </form>
                    </Col>
                </Row>
            </Col>
        </Row>
            
        </div>
        </div>
    );
};

export default translate('LoginPage')(LoginForm);


// WEBPACK FOOTER //
// ./src/components/loginForm/LoginForm.js